/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

import React, {Component} from "react";
import FailPage from "../digital-journey/FailPage";
import {sendToLogServer} from "./service/BusinessLogicService";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  async componentDidCatch(error, info) {
    this.setState({hasError: true});
    sendToLogServer("ERROR", "" + error.message + " " + info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return <FailPage/>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
